export const resolvingEventKey = 'request_instance';

export class DOMBindingResolver {
    /**
     * @type {HTMLElement}
     * @private
     */
    _element;

    /**
     * @type {{string:number}}
     * @private
     */
    _tries = {};

    /**
     * @type {number}
     * @private
     */
    _maxTries = 3;

    /**
     * @type {number}
     * @private
     */
    _millisecondsBetweenTries = 2500;

    /**
     * @param {HTMLElement} element
     */
    constructor(element) {
        this._element = element;
    }

    /**
     * @template T
     * @param {function(new:T)} abstract
     * @return {T}
     */
    resolve(abstract) {
        let event = this._newResolveEvent(abstract);
        this._element.dispatchEvent(event);
        return event.detail.instance;
    }

    /**
     * The same as resolve() but for string bindings.
     *
     * @param {string} binding
     * @return {Object}
     */
    get(binding) {
        // noinspection JSCheckFunctionSignatures
        return this.resolve(binding);
    }

    /**
     * Resolve the binding by the passed callback.
     *
     * @param {string|function} binding
     * @param {function} callback
     */
    bind(binding, callback) {
        DOMBindingResolver.handleResolveEvent(this._element, binding, callback);
    }

    /**
     * Provide a binding on some element from outside
     * @param {HTMLElement} element
     * @param {string} binding
     * @param {function} handler
     */
    static handleResolveEvent(element, binding, handler) {
        element.addEventListener(resolvingEventKey, event => {
            if (event.detail.binding === binding) {
                event.detail.instance = handler(binding);
                event.stopPropagation();
            }
        });
    }

    /**
     * Install a global instance resolver
     *
     * @param {HTMLElement} element
     * @param {function(function(new:T))} handler
     * @template T
     */
    static handleAllResolveEvents(element, handler) {
        element.addEventListener(resolvingEventKey, event => {
            let concrete = handler(event.detail.binding);
            if (concrete) {
                event.detail.instance = concrete;
                event.stopPropagation();
            }
        });
    }

    /**
     * @param {string} binding
     * @return CustomEvent
     * @private
     **/
    _newResolveEvent(binding) {
        return new CustomEvent(resolvingEventKey, {
            detail: {binding},
            bubbles: true,
            cancelable: true,
            composed: true
        });
    }
}